import { Reveal } from "@/components/site/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SPECS, AMENITIES, PROPERTY } from "@/data/property";
import { Check } from "lucide-react";

export function Amenities() {
  return (
    <section id="amenities" className="relative bg-background py-24 md:py-40 overflow-hidden">
      <span
        aria-hidden
        className="pointer-events-none absolute top-8 right-4 md:right-12 font-display text-[9rem] md:text-[16rem] leading-none text-accent/10 select-none"
      >
        02
      </span>

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="text-xs sm:text-sm uppercase tracking-[0.22em] text-accent font-medium mb-6">
              Chapter 02 — The Essentials
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-foreground text-balance">
              Everything you need, <em className="italic font-light">nothing you don't.</em>
            </h2>
          </Reveal>

          <div className="mt-12 grid grid-cols-2 gap-8">
            {SPECS.map((s) => (
              <Reveal key={s.label} delay={0.05}>
                <div className="border-t border-border pt-4">
                  <div className="font-display text-5xl md:text-6xl text-primary leading-none">{s.value}</div>
                  <div className="mt-2 text-xs uppercase tracking-[0.18em] text-muted-foreground">{s.label}</div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="mt-12 w-full" data-testid="amenities-accordion">
              <AccordionItem value="fees" className="border-border">
                <AccordionTrigger className="font-display text-xl hover:no-underline">Are there hidden fees?</AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-light">
                  None. {PROPERTY.priceNote} The rate you see on VRBO is the rate you pay.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="group" className="border-border">
                <AccordionTrigger className="font-display text-xl hover:no-underline">How big a group fits comfortably?</AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-light">
                  Six bedrooms and six bathrooms sleep up to 18 — including 4 private en-suite bedrooms — ideal for multiple families, reunions, or an entire baseball team.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="area" className="border-none">
                <AccordionTrigger className="font-display text-xl hover:no-underline">What's nearby?</AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-light">
                  Minutes from Possum Kingdom Lake restaurants and shops, and about 15 minutes from Rocker B Ranch.
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal delay={0.1}>
            <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-8">The full list</p>
            <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-4">
              {AMENITIES.map((a) => (
                <li key={a} className="flex items-center gap-3 border-b border-border/60 pb-4 text-foreground">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent/12 text-accent">
                    <Check className="h-3.5 w-3.5" strokeWidth={2.2} />
                  </span>
                  <span className="text-base font-light">{a}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
